import {ApplicationPacketEnum, UserQuery} from "../graphql-types";

export class DocumentService {
    static HasWorkRecord(info?: UserQuery): boolean {
        return !!info?.user?.companySettings?.applicationPackets?.find(
            (f) => f.packet === ApplicationPacketEnum.WorkRecords,
        );
    }

    static HasTravelWarrant(info?: UserQuery): boolean {
        return !!info?.user?.companySettings?.applicationPackets?.find(
            (f) => f.packet === ApplicationPacketEnum.TravelWarrants,
        );
    }

    static HasTravelWarrant2(info?: UserQuery): boolean {
        return !!info?.user?.companySettings?.applicationPackets?.find(
            (f) => f.packet === ApplicationPacketEnum.TravelWarrants2,
        );
    }
}
